import { takeLatest, all, put, call } from 'redux-saga/effects';

import { openIndicator } from '@coconut/services/redux/questionIndicator';

import apis from '../apis/chat';
import { appendMessage } from '../redux/chatsMessage';

import {
  types,
  endSessionSuccess,
  endSessionFailed,
} from '../redux/endSession';

function* endSessionFlow(action) {
  const {
    payload: { QID },
  } = action;

  try {
    const response = yield call(apis.endSession, QID);

    const {
      data: { message },
    } = response;

    // append chatbot message.
    yield put(appendMessage(message));

    yield put(endSessionSuccess());

    // activate question indicator
    yield put(openIndicator());
  } catch (err) {
    yield put(endSessionFailed(err));
  }
}

export default function* () {
  yield all([takeLatest(types.END_SESSION, endSessionFlow)]);
}



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/sagas/endSession.js